<template>
  <v-dialog
    v-model="updateOnHoldDialog"
    scrollable
    max-width="700px"
    persistent
  >
    <v-card>
      <v-toolbar color="white" fixed>
        <h3>{{ $i18n.t("Update Supplier Hold Amount") }}</h3>
      </v-toolbar>
      <v-card-text>
        <v-container dense>
          <v-form ref="form">
            <v-row>
              <v-col cols="12" sm="6" md="6" lg="6">
                <v-text-field
                  v-model="newOnHold.amount"
                  :label="$i18n.t('Amount')"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6">
                <v-select
                  v-model="newOnHold.status"
                  :label="$i18n.t('Status') + '*'"
                  :items="[
                    { name: 'On Hold', value: 0 },
                    { name: 'Cleared', value: 1 },
                  ]"
                  item-text="name"
                  item-value="value"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-text-field
                  v-model="newOnHold.comment"
                  :label="$i18n.t('Type Comment Here')"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click="closeOnHoldDialog"
          >Close</v-btn
        >
        <v-spacer />
        <v-btn
          color="success darken-1"
          @click="returnOnHold()"
          :disabled="!newOnHold.comment"
          >{{ $i18n.t("Update") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component, Watch } from "vue-property-decorator";
import { doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "OnHoldUpdate",
  props: {
    value: {
      default: false,
    },
    onHold: {
      default: null,
    },
    trip_id: {
      default: null,
    },
    supplier_id: {
      default: null,
    },
    showUpdateOnHold: {
      default: null,
    },
  },
  components: {},
})
export default class OnHoldUpdate extends (Vue, Themeable) {
  updateOnHoldDialog = null;
  newOnHold = { amount: null, status: 0, comment: null };
  mounted() {
    if (this.onHold) {
      this.newOnHold.amount = this.onHold.amount;
      this.newOnHold.status = this.onHold.status;
      this.newOnHold.comment = null;
    }
  }
  async returnOnHold() {
    if (this.trip_id) {
      const data = {};
      data.amount = this.newOnHold.amount;
      data.status = this.newOnHold.status;
      data.comment = this.newOnHold.comment;

      try {
        common.setLoading(true);
        await doPost(
          "/api/trip/" +
            this.trip_id +
            "/onhold/add?supplier_id=" +
            this.supplier_id,
          data
        );
        common.setLoading(false);
        this.$emit("reload", true);
        this.closeOnHoldDialog();
      } catch (e) {
        common.setLoading(false);
        common.setError(e);
      }
    }
  }
  closeOnHoldDialog() {
    this.$emit("closeOnHoldDialog", true);
    this.updateOnHoldDialog = null;
  }
  @Watch("showUpdateOnHold")
  onDialogValChange(val) {
    this.updateOnHoldDialog = val;
  }
}
</script>

<style scoped>
.card-title-head {
  background-color: rgb(211, 235, 240);
  height: 40px;
  padding-top: 0px;
  color: #3b7776;
}
</style>
